import { connect } from 'react-redux';

import { getDashboardEvenIds } from '../../../../../reducers/analyticsApp';
import EventsView from '../../../../../components/dashboards/cards/builder/event/View';
import { addEvent } from '../../../../../actions/dashboards/events';

const mapStateToProps = (state, { unit }) => ({
  eventIds: getDashboardEvenIds(state, unit.id),
});

const mapDispatchToProps = {
  onEventAdd: addEvent,
};

const ViewContainer = connect(mapStateToProps, mapDispatchToProps)(EventsView);

export default ViewContainer;
